import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const HeaderConfiguration = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px;

  span {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: center;

    color: #ffffff;
  }
`;
export const HeaderFilterContactAndExtension = styled.div`
  display: flex;
  gap: 10px;
`;

export const ContactAndExtensionButton = styled.div`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-family: "Poppins" !important;
  font-size: 12px;
  font-style: normal;
  font-weight: ${(props) => (props.check ? 700 : 400)};
  line-height: normal;

  &:hover {
    opacity: 0.5;
  }
`;

export const CheckFilter = styled.div`
  display: ${(props) => (props.check ? "flex" : "none")};
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #fff;
  bottom: -2, 5px;
  left: 0;
`;

export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #a7a7a7;

  input {
    width: 100%;
    height: 30px;
    outline: none;
    border: none;
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;
  }
`;
export const FilterContainer = styled.div``;
export const FilterContent = styled.div`
  position: absolute;
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;
  width: 205px;
  height: 124px;
  box-sizing: border-box;
  padding: 10px;
  z-index: 9999;
  right: 0px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  border-radius: 2px;

  span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #4d4d4d;
    cursor: pointer;
  }
`;
export const ListFilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #a7a7a7;

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1px;
    background: #36aae2;
    border-radius: 5px;
    margin-left: 10px;
  }

  span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #ffffff;
    margin-right: 10px;
  }
`;
export const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #949494;
    border-radius: 4px;
  }
`;
export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  width: 100%;
  box-sizing: border-box;

  h1 {
    position: relative;
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 60px;
    margin-left: 10px;
    border-bottom: 1px solid #a7a7a7;

    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;

    div {
      display: flex;
      flex-direction: column;

      span {
        color: #4d4d4d;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
      }
    }
  }
`;

export const Status = styled.div`
  min-width: 8px;
  min-height: 8px;
  margin: 5px;
  border-radius: 50%;
  background: ${(props) => (props.color ? props.color : "#C4C4C4")};
  cursor: pointer;
  div {
    visibility: hidden;
  }
  :hover {
    div {
      visibility: visible;
    }
  }
`;

export const Toltip = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 1px;
  background: ${(props) => (props.color ? props.color : "#C4C4C4")};
  border-radius: 20px;
  padding: 1px 4px;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;

  color: #ffffff;
`;
export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 57px;
  min-height: 57px;

  margin-left: 5px;
  border-radius: 50%;
  background: #c4c4c4;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;

  img {
    width: 57px;
    height: 57px;
    border-radius: 50%;
  }
`;
